<script setup lang="ts">
const { data: footer } = await useAsyncData('component-footer', () =>
  queryCollection('componentFooter').first(),
)

const { trackEvent } = useAnalytics()

function handleKaweahTechClick() {
  trackEvent('external_link_clicked', {
    destination: 'kaweah_tech',
    source: 'footer',
  })
}

// Split the credit line around the {kaweahTech} placeholder so the brand
// phrase can be wrapped in an anchor without inheriting any distinct
// styling (no color, no underline by default — only a hover underline).
const creditParts = computed(() => {
  const line = footer.value?.credit.line ?? ''
  const [ before, after = '' ] = line.split('{kaweahTech}')
  return { after, before }
})
</script>

<template>
  <footer v-if="footer" class="relative overflow-hidden bg-brand-chalk text-brand-ink border-t border-brand-line">
    <SfgSurfaceTexture variant="chalk"/>
    <div class="relative z-10 mx-auto max-w-7xl px-6 py-10 sm:px-10 sm:py-14">
      <div class="flex flex-col gap-8 md:flex-row md:items-center md:justify-between">
        <div class="flex items-center gap-3">
          <SfgFlame
            :size="40"
            :disk="false"
            body-color="red"
            flame-color="yellow"
            :tilt="1"
          />
          <div class="flex flex-col leading-tight">
            <span class="font-display uppercase text-[14px] tracking-[0.08em]">{{ footer.wordmark.label }}</span>
            <span class="font-body text-[12px] opacity-70">{{ footer.wordmark.sublabel }}</span>
          </div>
        </div>

        <nav class="flex flex-wrap justify-start gap-x-6 gap-y-2 md:justify-end">
          <NuxtLink
            v-for="item in footer.nav"
            :key="item.label"
            :to="item.to"
            class="font-display uppercase text-[12px] tracking-[0.14em] hover:text-brand-red transition-colors"
          >
            {{ item.label }}
          </NuxtLink>
        </nav>
      </div>

      <hr class="my-8 border-0 border-t border-brand-line">

      <p class="text-center font-body text-[12px] opacity-70">
        {{ footer.credit.year }} / {{ creditParts.before }}<a
          :href="footer.credit.kaweahTechUrl"
          target="_blank"
          rel="noopener"
          class="text-inherit no-underline hover:underline"
          @click="handleKaweahTechClick"
        >Kaweah Tech</a>{{ creditParts.after }}
      </p>
    </div>
  </footer>
</template>
